import { render, staticRenderFns } from "./editUserInfo.vue?vue&type=template&id=1e828807&scoped=true"
import script from "./editUserInfo.vue?vue&type=script&lang=ts"
export * from "./editUserInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e828807",
  null
  
)

export default component.exports